export default __webpack_public_path__ + "static/media/review6.c95e9510.jpg";